var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactShop = function SvgContactShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M19 35.423V45h15v-9.577l-7.5-6.735-7.5 6.735zm-1.336-1.488l7.5-6.735a2 2 0 0 1 2.672 0l7.5 6.735A2 2 0 0 1 36 35.423V45a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2v-9.577a2 2 0 0 1 .664-1.488zm19.462-6.422a2 2 0 0 1 1.057-.302H45V19H33v8.211a2 2 0 0 1 1.714 1.806c0-.002.804-.503 2.412-1.504zm1.057 1.698l-2.412 1.501a2 2 0 0 1-3.049-1.52A2 2 0 0 1 31 27.212V19a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8.211a2 2 0 0 1-2 2h-6.817zM39 24a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })));
};
export default SvgContactShop;